module.exports = __webpack_public_path__ + "static/media/gold-medal-icon.0fe1f9c3.png";